export const siteConfig = {
  name: "Wilson Point",
  description: "Financial Services for Individuals and Families",
};
